/** Convierte ISO a dd/MM/yyyy requerido por SRI */
export function formatFecha(isoDate) {
  const d = new Date(isoDate);
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
}

/** Secuencial de 9 dígitos con ceros a la izquierda */
export function padSecuencial(numero) {
  return String(numero).padStart(9, '0');
}

/** Escapa caracteres especiales XML */
export function sanitizeXml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');
}

/** Tipo de identificación según longitud/tipo del documento */
export function getTipoIdentificacion(doc) {
  if (!doc) return '07'; // consumidor final
  const clean = doc.replace(/\D/g, '');
  if (clean.length === 13) return '04'; // RUC
  if (clean.length === 10) return '05'; // Cédula
  return '06';                          // Pasaporte / otro
}

/** Calcula IVA con 2 decimales */
export function calcularIVA(base, porcentaje) {
  return Math.round(base * porcentaje / 100 * 100) / 100; // número, no string
}

/**
 * Genera clave de acceso de 49 dígitos con dígito verificador módulo 11.
 * Parámetros: { fecha:'ddMMaaaa', codDoc, ruc, ambiente, estab, ptoEmi, secuencial, tipoEmision }
 */
export function calcularClaveAcceso({ fecha, codDoc, ruc, ambiente, estab, ptoEmi, secuencial, tipoEmision }) {
  // Código numérico aleatorio de 8 dígitos
  const codigoNumerico = String(Math.floor(Math.random() * 99999999)).padStart(8, '0');

  // fecha: dd/MM/yyyy → ddMMaaaa (sin barras)
  const fechaSri = fecha.replace(/\//g, '');

  const clave48 =
    fechaSri +        // 8 dígitos
    codDoc +          // 2 dígitos
    ruc +             // 13 dígitos
    ambiente +        // 1 dígito
    estab +           // 3 dígitos
    ptoEmi +          // 3 dígitos
    secuencial +      // 9 dígitos
    codigoNumerico +  // 8 dígitos
    tipoEmision;      // 1 dígito
  // Total: 48 dígitos + 1 verificador = 49

  // Módulo 11 (algoritmo SRI)
  const digito = modulo11(clave48);
  return clave48 + digito;
}

function modulo11(clave) {
  const digits = clave.split('').reverse();
  let suma = 0;
  let multiplicador = 2;
  for (const d of digits) {
    suma += parseInt(d) * multiplicador;
    multiplicador = multiplicador === 7 ? 2 : multiplicador + 1;
  }
  const residuo = suma % 11;
  if (residuo === 0) return '0';
  if (residuo === 1) return '1';
  return String(11 - residuo);
}